export const environment = {
  production: false,
  //api: 'http://localhost:3000/api/'
  api: 'https://crm-tic-back-29ydx.ondigitalocean.app/api/'
};
